import Vue from "vue";
import VueCookies from "vue-cookies";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./plugins/validate";
import { i18n } from "./plugins/i18n";
import store from "./store";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.use(VueCookies);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  i18n,
  store,
  render: h => h(App)
}).$mount("#app");
